module.exports = __webpack_public_path__ + "static/media/IMG_6423.34d58e25.JPG";